'use strict';

import Api from "./Api";

export default class Sms extends Api {

    static getBalance() {
        const url = this.url + 'sms/get-balance';

        return this.getAxios().get(url, {});
    }

    static clientSend(clientId, text) {
        const url = this.url + 'sms/client-send';

        return this.getAxios().post(url, {
            client_id: clientId,
            text: text,
        });
    }

}
